import { EllipsisCommonProps } from './Ellipsis.types';

type ExtractedProps =
  | 'appendTo'
  | 'disabled'
  | 'ellipsis'
  | 'enterDelay'
  | 'exitDelay'
  | 'fixed'
  | 'flip'
  | 'maxWidth'
  | 'moveArrowTo'
  | 'onHide'
  | 'onShow'
  | 'placement'
  | 'showTooltip'
  | 'textAlign'
  | 'zIndex'
  | 'maxLines'
  | 'onEllipsisStateChange';

type ExtractedEllipsisProps = Pick<EllipsisCommonProps, ExtractedProps>;

/**
 * A utility function that extracts Ellipsis relevant props and wrapped Component relevant props
 * @returns {{ellipsisProps: *, componentProps: *}}
 */
export const extractEllipsisProps = <T extends ExtractedEllipsisProps>({
  appendTo,
  disabled,
  ellipsis,
  enterDelay,
  exitDelay,
  fixed,
  flip,
  maxWidth,
  moveArrowTo,
  onHide,
  onShow,
  placement,
  showTooltip,
  textAlign,
  zIndex,
  maxLines,
  onEllipsisStateChange,
  ...componentProps
}: T): {
  ellipsisProps: ExtractedEllipsisProps;
  componentProps: Omit<T, ExtractedProps>;
} => {
  return {
    ellipsisProps: {
      appendTo,
      disabled,
      ellipsis,
      enterDelay,
      exitDelay,
      fixed,
      flip,
      maxWidth,
      moveArrowTo,
      onHide,
      onShow,
      placement,
      showTooltip,
      textAlign,
      zIndex,
      maxLines,
      onEllipsisStateChange,
    },
    componentProps,
  };
};
